/* custom-benefits-carousel.js */
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.benefits-carousel');

  carousels.forEach((carousel) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    // Detectar Mousedown
    carousel.addEventListener('mousedown', (e) => {
      isDown = true;
      carousel.classList.add('active'); // Opcional, para estilo do cursor active: grabbing
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
      // Impede interrupção na animação nativa se o usuário começar a arrastar
      carousel.style.scrollSnapType = 'none'; 
    });

    // Detectar quando o mouse sai da região
    carousel.addEventListener('mouseleave', () => {
      isDown = false;
      carousel.classList.remove('active');
      carousel.style.scrollSnapType = 'x mandatory'; 
    });

    // Detectar Mouseup (Soltar clique)
    carousel.addEventListener('mouseup', () => {
      isDown = false;
      carousel.classList.remove('active');
      carousel.style.scrollSnapType = 'x mandatory'; 
    });

    // Movimentar Carrossel Dragging
    carousel.addEventListener('mousemove', (e) => {
      if (!isDown) return; // Parar se não estiver clicando
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 2; // Multiplicador base: Velocidade da rolagem (2x)
      carousel.scrollLeft = scrollLeft - walk;
    });
  });
});
